import { render } from "./eproc_en.vue?vue&type=template&id=576617e8"
import script from "./eproc_en.vue?vue&type=script&lang=js"
export * from "./eproc_en.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__